module.exports = __webpack_public_path__ + "9f5a77f8b951bbd5747f85462e30d3a0.png";